import React, { useEffect } from "react";
import "../src/styles/global.scss";
import "../src/styles/custom.scss";

import {
  createBrowserRouter,
  Outlet,
  RouterProvider,
  useNavigate,
} from "react-router-dom";
import { ScreenSizeProvider, useScreenSize } from "./ScreenSizeContext";
import { isEmpty } from "./utils/validation";

//Static
import BottomBar from "./components/bottomBar/BottomBar";
import SnackBar from "./components/snackbar/Snackbar";
import MenuBar from "./components/menuBar/MenuBar";

//pages
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import ForgetPassword from "./pages/forgetPassword/ForgetPassword";
import Registration from "./pages/registration/Registration";
import ConfirmRegistration from "./pages/confirmRegistration/ConfirmRegistration";
import ConfirmForgetPassword from "./pages/confirmForgetPassword/ConfirmForgetPassword";
import Settings from "./pages/settings/Settings";
import ChangePassword from "./pages/changePassword/ChangePassword";
import Notifications from "./pages/notifications/Notifications";
import MyAssociations from "./pages/myAssociations/MyAssociations";
import NotificationDetails from "./pages/notificationDetails/NotificationDetails";
import ListAssociation from "./pages/listAssociations/ListAssociations";
import Explore from "./pages/explore/Explore";
import Calendar from "./pages/calendar/Calendar";
import Dashboard from "./pages/dashboard/Dashboard";
import RequestShift from "./pages/requestShift/RequestShift";
import EventOfAssociation from "./pages/eventOfAssociation/EventOfAssociation";
import NotificationsBoard from "./pages/notificationsBoard/NotificationsBoard";
import Event from "./pages/event/Event";
import ListVolunteer from "./pages/listVolunteer/ListVolunteer";
import SendNotification from "./pages/sendNotification/SendNotification";
import CreateEvent from "./pages/createEvent/CreateEvent";
import EditUser from "./pages/editUser/EditUser";
import Association from "./pages/association/Association";
import EditAssociation from "./pages/editAssociation/EditAssociation";
import MyEvent from "./pages/myEvent/MyEvent";
import CreateAssociation from "./pages/createAssociation/CreateAssociation";
import ShiftDetails from "./pages/shiftDetails/ShiftDetails";
import PrivacyPolicy from "./pages/privacyPolicy/PrivacyPolicy";
import TermOfUse from "./pages/termOfUse/TermOfUse";
import InvitationVolunteerOfAssociation from "./pages/invitationVolunteerOfAssociation/InvitationVolunteerOfAssociation";

import ErrorPage from "./pages/errorPage/ErrorPage";

import { ReloadProvider } from "./ReloadContext";
import UserQuestion from "./pages/userQuestion/UserQuestion";
import ListQuestion from "./pages/listQuestion/ListQuestion";
import AnswerQuestion from "./pages/answerQuestion/AnswerQuestion";
import SendMailConfirmRegistration from "./pages/sendMailConfirmRegistration/SendMailConfirmRegistration";

function App() {
  const Layout = () => {
    const navigate = useNavigate();
    const isPC = useScreenSize();

    useEffect(() => {
      if (isEmpty(localStorage.getItem("accessToken"))) {
        navigate("/login");
      }
    }, []);

    return (
      <div className="main">
        <div className="container-main">
          <Outlet />
        </div>
        {isPC ? <MenuBar /> : <BottomBar />}
        <SnackBar /> {/* Errori e successi di operazioni */}
      </div>
    );
  };

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      errorElement: <ErrorPage />,
      children: [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/settings",
          element: <Settings />,
        },
        {
          path: "/settings/edit-user",
          element: <EditUser />,
        },
        {
          path: "/explore",
          element: <Explore />,
        },
        {
          path: "/event/:id_event",
          element: <Event />,
        },
        {
          path: "/event/:id_event/:id_shift",
          element: <ShiftDetails />,
        },
        {
          path: "/association/:id_association",
          element: <Association />,
        },
        {
          path: "/user-question/:id_association",
          element: <UserQuestion />,
        },
        {
          path: "/list-associations",
          element: <ListAssociation />,
        },
        {
          path: "/my-event",
          element: <MyEvent />,
        },
        {
          path: "/notifications",
          element: <Notifications />,
        },
        {
          path: "/notifications/:id_notification",
          element: <NotificationDetails />,
        },
        {
          path: "/calendar",
          element: <Calendar />,
        },
        {
          path: "/dashboard",
          element: <MyAssociations />,
        },
        {
          path: "/dashboard/:id_association",
          element: <Dashboard />,
        },
        {
          path: "/dashboard/:id_association/request-shift",
          element: <RequestShift />,
        },
        {
          path: "/dashboard/:id_association/list-events",
          element: <EventOfAssociation />,
        },
        {
          path: "/dashboard/:id_association/notifications-board-association",
          element: <NotificationsBoard />,
        },
        {
          path: "/dashboard/:id_association/list-volunteers",
          element: <ListVolunteer />,
        },
        {
          path: "/dashboard/:id_association/send-notification",
          element: <SendNotification />,
        },
        {
          path: "/dashboard/:id_association/edit-association",
          element: <EditAssociation />,
        },
        {
          path: "/dashboard/:id_association/create-event",
          element: <CreateEvent />,
        },
        {
          path: "/dashboard/:id_association/list-question",
          element: <ListQuestion />,
        },
        {
          path: "/dashboard/:id_association/list-question/:id_question",
          element: <AnswerQuestion />,
        },
      ],
    },
    {
      path: "/login",
      element: <Login />,
      errorElement: <ErrorPage />,
    },
    {
      path: "/forget-password",
      element: <ForgetPassword />,
      errorElement: <ErrorPage />,
    },
    {
      path: "/registration",
      element: <Registration />,
      errorElement: <ErrorPage />,
    },
    {
      path: "/send-mail-confirm-registration",
      element: <SendMailConfirmRegistration />,
      errorElement: <ErrorPage />,
    },
    {
      path: "/confirm-registration/:id",
      element: <ConfirmRegistration />,
      errorElement: <ErrorPage />,
    },
    {
      path: "/confirm-forget-password/:id",
      element: <ConfirmForgetPassword />,
      errorElement: <ErrorPage />,
    },
    {
      path: "/change-password",
      element: <ChangePassword />,
      errorElement: <ErrorPage />,
    },
    {
      path: "/create-association",
      element: <CreateAssociation />,
      errorElement: <ErrorPage />,
    },
    {
      path: "/invitation-volunteer/:id_association",
      element: <InvitationVolunteerOfAssociation />,
    },
    {
      path: "/privacy-policy",
      element: <PrivacyPolicy />,
    },
    {
      path: "/term-of-use",
      element: <TermOfUse />,
    },
  ]);

  return (
    <ScreenSizeProvider>
      <ReloadProvider>
        <RouterProvider router={router} />
      </ReloadProvider>
    </ScreenSizeProvider>
  );
}

export default App;
